export const URL_SEARCH_PARAM = {
    TRANS: 'trans',
    OFF: 'off',
    REF: 'ref',
    IR_CLICKED: 'irclickid',
    SS_CID: 'sscid',
    UTM_SOURCE: 'utm_source',
    KEYWORD: 'keyword',
    AD_SET_NAME: 'adset_name',
    AD_NAME: 'ad_name',
    UTM_CAMPAIGN: 'utm_campaign',
    UTM_CONTENT: 'utm_content',
    UTM_TERM: 'utm_term',
    UTM_MEDIUM: 'utm_medium',
    MP_ID: 'mpid',
    FB_CL_ID: 'fbclid',
    GCL_ID: 'gclid',
    IR_CLICK_ID: 'irclickid',
    REFERRER: 'referrer',
    MS_CLK_ID: 'msclkid',
    COUPON: 'coupon',
    MATCH_TYPE: 'matchtype',
    CREATIVE: 'creative',
    PLACEMENT: 'placement',
    CAMPAIGN_ID: 'campaign_id',
    AD_SET_ID: 'adset_id',
    AD_ID: 'ad_id',
    NETWORK: 'network',
    DEVICE: 'device',
    AD_SET__NAME: 'ad_set name',
    DEVICE_ID: 'deviceid',
    ANALYTICS_PAYLOAD: 'analytics_payload',
    USER_REFERRER: 'r',
};
export var Referrer;
(function (Referrer) {
    Referrer["SEM"] = "SEM";
    Referrer["GDN"] = "GDN";
    Referrer["FACEBOOK"] = "FACEBOOK";
    Referrer["BING"] = "BING";
    Referrer["YOUTUBE"] = "YOUTUBE";
    Referrer["BLOG"] = "BLOG";
    Referrer["SHARE_SALE_AFFILIATE"] = "shareasaleAffiliate";
    Referrer["IMPACT_AFFILIATE"] = "impactAffiliate";
    Referrer["TECH_FILIATE_AFFILIATE"] = "techfiliateAffiliate";
    Referrer["AFFILIATE"] = "affiliate";
    Referrer["WEBSITE"] = "website";
    Referrer["APP"] = "app";
    Referrer["VIDEOCREEK"] = "videocreek";
    Referrer["IMAGETOVIDEO"] = "imagetovideo";
    Referrer["KIZOA"] = "kizoa";
})(Referrer || (Referrer = {}));
export const TARGET = {
    TECH_FILIATE: 'techfiliate',
    AFFILIATE: 'affiliate',
    SHARE_SALE: 'shareasale',
    IMPACT: 'impact',
};
export const SOURCE = {
    BACK_LINK: 'backlink',
};
export const UTM_MEDIUM_VALUES = {
    CPC: 'cpc',
    CPV: 'cpv',
    SOCIAL: 'social',
};
export const UTM_SOURCE_VALUES = {
    GOOGLE: 'google',
    GDN: 'gdn',
    FACEBOOK: 'facebook',
    BING: 'bing',
    YOUTUBE: 'youtube',
    BLOG: 'blog',
};
export const COOKIE_KEYS = {
    QUERY_PARAMS: 'query_params',
};
export const SESSION_KEYS = {
    NOV_SETTING: 'nov-setting-2',
    NO_LOGIN_EXP: 'no-login-exp',
    NEW_USER: 'new_user',
};
export const DOMAIN = {
    LANDING_PAGE: 'landingPage',
    YOUTUBE: 'YOUTUBE',
    SEM: 'SEM',
    GDN: 'GDN',
    FACEBOOK: 'FACEBOOK',
    BING: 'BING',
};
export const CATEGORY = {
    PRICING_PAGE: 'pricingPage',
    WEBSITE: 'website',
    HOME_PAGE: 'homePage',
};
export const ENV = {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    PRODUCTION: 'production',
};
export const LOCAL_STORAGE = {
    USER: 'user',
    AMPLITUDE_DEVICE_DETAILS: 'amplitude_device_details',
    BUTTON_POSITION: 'Button Position',
    FIRST_TOUCH_POINT: 'first_touch_point',
    INITIAL_RAW_URL: 'initial_raw_url',
    AUTH_TOKEN: 'authToken',
    AUTH_EXPIRES: 'authExpires',
    ACCOUNT_DETAILS: 'accountDetails',
    SESSION_ID: 'amplitude_session_id',
};
export const AUTH_COOKIE = {
    AUTH_TOKEN: 'cfauth',
};
export const USER_COOKIE = {
    USER_STATE: 'user-state',
    USER_DATA: 'user_data',
    USER_DETAILS: 'user_details',
    COUPON: 'coupon',
};
export const CHANNEL = {
    BRANDED_PAID_SEARCH: 'Branded Paid Search',
    DISPLAY: 'Display',
    PAID_YOUTUBE: 'Paid Youtube',
    PAID_SEARCH: 'Paid Search',
    PAID_SOCIAL: 'Paid Social',
    ORGANIC_SEARCH: 'Organic Search',
    EMAIL: 'Email',
    AFFILIATE: 'Affiliate',
    ORGANIC_SOCIAL: 'Organic Social',
    REFERRAL: 'Referral',
    USER_REFERRAL: 'User Referral',
};
export const PAGE_TYPE = {
    MAKE: 'Make Page',
    BLOG: 'Blog Page',
    TOOLS: 'Tools Page',
    TERMS_AND_POLICY: 'Terms and Policy Page',
    CREATOR: 'Creator Page',
    SIGNUP: 'Signup Page',
    MOBILE_LANDING_PAGE: 'Mobile Landing Page',
    BLANK: '',
    TEMPLATE_CATEGORY: 'Template Category',
    VIDEOWALL_CATEGORY: 'Videowall Category',
};
export const LANGUAGE = {
    en: 'English',
    es: 'Spanish',
    fr: 'French',
    ru: 'Russian',
    pt: 'Portuguese',
    id: 'Indonesian',
    it: 'Italian',
    de: 'German',
    my: 'Malay',
    jp: 'Japanese',
    'zh-CN': 'Chinese Simplified',
    'zh-TW': 'Chinese Traditional',
};
export const BRAZE_EVENTS = {
    'App Load': {
        event_properties: ['Page source', 'Pagetype'],
        user_properties: [],
    },
    'View workflow page': {
        event_properties: ['Workflow', 'Page source', 'Pagetype'],
        user_properties: [],
    },
    'View Advanced Editor': {
        event_properties: [
            'Browser',
            'Template Id',
            'Template Dimension',
            'Template Type',
        ],
        user_properties: [],
    },
    'View Storyboard': {
        event_properties: ['Url', 'Template Type'],
        user_properties: [],
    },
    'View Checkout': {
        event_properties: ['Url', 'Pagetype'],
        user_properties: [],
    },
    'View Pricing': {
        event_properties: ['Url', 'Pagetype'],
        user_properties: [],
    },
    'Export a Video': {
        event_properties: ['Template Dimension', 'Template Type', 'Unique'],
        user_properties: [
            'Number of projects exported',
            'Total number of videos exported',
        ],
    },
    'Start Subscription FE': {
        event_properties: [
            'Plan',
            'Currency',
            'Plan Duration',
            'Coupon',
            'Amount in USD',
        ],
        user_properties: ['Plan Duration', 'Plan'],
    },
    'submit onboarding typeform': {
        event_properties: ['Page source', 'Pagetype'],
        user_properties: [
            'Country',
            'Where to publish',
            'UserMustHave',
            'User Industry',
            'User Age',
            'User JobType',
            'User Persona',
            'User Anxiety',
            'User Expectation',
            'User Guidance',
            'User Reason',
        ],
    },
    'View dashboard': {
        event_properties: ['Page source', 'Pagetype'],
        user_properties: [],
    },
    'Select Template': {
        event_properties: ['Url', 'Template dimension', 'Template type'],
        user_properties: [],
    },
    'iStock quota exhausted': {
        event_properties: ['Plan Duration', 'Plan'],
        user_properties: [],
    },
    'Export quota exhausted': {
        event_properties: ['Plan Duration', 'Plan'],
        user_properties: [],
    },
    'Tool Get Link': {
        event_properties: [],
        user_properties: ['Trim Tool Email Id'],
    },
};
